// extracted by mini-css-extract-plugin
export var button = "empty-messages-screen-module--button--5e7d7";
export var description = "empty-messages-screen-module--description--cbbee";
export var title = "empty-messages-screen-module--title--3eecb";
export var wrapper = "empty-messages-screen-module--wrapper--3dcd4";